import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const MuiDoubleLabelWithFormattedPhoneTextWrapper = styled.div`
  width: 100%;
  flex-direction: column;
  display: flex;

  .value-style {
    color: ${COLORS.cirrus_black};
    line-height: 20px;
  }

  .label-style {
    color: ${COLORS.cirrus_black};
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
